import { type ComponentProps } from 'react'

import { FilterListItem } from '@/components/common/Filter'
import {
  FILTER_ADVANCED_COUNT_VALUE_OPERATOR_LABELS,
  FILTER_ADVANCED_PRICE_VALUE_OPERATOR_LABELS,
  FILTER_ADVANCED_SLUG_LABELS,
  type FilterAdvancedType,
  isFilterAdvancedCardType,
  isFilterAdvancedCountType,
  isFilterAdvancedPriceType,
} from '@/defs/filters'

type Props = {
  filter: FilterAdvancedType
  onDelete: () => void
  onEdit: () => void
}

const getVars = (filter: FilterAdvancedType): Omit<ComponentProps<typeof FilterListItem>, 'onEdit' | 'onDelete'> => {
  if (isFilterAdvancedCardType(filter)) {
    return {
      icon: FILTER_ADVANCED_SLUG_LABELS[filter.slug].icon,
      label: `${FILTER_ADVANCED_SLUG_LABELS[filter.slug].label}: ${filter.card}`,
      variant: filter.slug === 'withCard' ? 'success' : 'warning',
    }
  }
  if (isFilterAdvancedCountType(filter)) {
    return {
      icon: FILTER_ADVANCED_SLUG_LABELS[filter.slug].icon,
      label: `${FILTER_ADVANCED_COUNT_VALUE_OPERATOR_LABELS[filter.operator].labelLong} ${filter.number} ${FILTER_ADVANCED_SLUG_LABELS[filter.slug].label}`,
    }
  }
  if (isFilterAdvancedPriceType(filter)) {
    return {
      icon: FILTER_ADVANCED_SLUG_LABELS[filter.slug].icon,
      label: `${FILTER_ADVANCED_SLUG_LABELS[filter.slug].label}: ${FILTER_ADVANCED_PRICE_VALUE_OPERATOR_LABELS[filter.operator].labelLong} $${filter.number.toLocaleString()}`,
    }
  }
  return {
    icon: 'question',
    label: 'N/A',
  }
}

export const FiltersPanelAdvancedItem = ({ filter, ...props }: Props) => (
  <FilterListItem {...{ ...getVars(filter), ...props }} />
)
